<template>
  <div id="app">
    <div class="row">
      <div class="col-12">
        <h2 class="generalTitle">Incidencias
          <a href="#" class="float-right" @click="openIssueModal('newIssue')">
            <v-icon name="hi-plus" scale="1.2" />Añadir incidencia
          </a>
        </h2>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12 mb-3">
        <list-filters @filter="filter($event)" />
      </div>
      <div class="col-12" v-if="issues && issues.length > 0">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists }">
          <div class="card-body pb-0">
            <div>
              <p class="mb-2">Mostrando {{ from }}-{{ to }} de {{ totalItems }}
                incidencias</p>
            </div>
            <list :issues="issues" @selectOrder="selectOrder($event)" @sendRefreshIssuesList="sendRefreshIssuesList()" />
            <div class="row">
              <div class="col-12 col-sm-8 col-lg-5">
                <div class="form-group" v-if="numberPages > 1">
                  <div class="float-left mr-3 mt-2">
                    <select v-model="itemsPerPage" class="form-control" id="itemsPerPage" @change="changeItemsPerPage()">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label for="itemsPerPage" class="col-form-label mt-2">Incidencias por página</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-7" v-if="numberPages > 1">
                <pagination :currentPage=currentPage :numberPages=numberPages @selectPage="selectPage($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center" v-else>
        <img class="mt-5" v-if="loading" src="../../../../assets/loaderPrimary.svg" height="60" alt="">
        <div v-if="!loading" class="alert alert-info">No hay resultados para mostrar</div>
      </div>
    </div>
    <NewIssue :id="'newIssue'" v-if="showNewIssueModal" :modalTitle="'NUEVA INCIDENCIA'" :class="'modal-lg'" :showFooter="false"  @closeModal="showNewIssueModal = false" @sendRefreshIssuesList="loadIssues()"></NewIssue>
  </div>
</template>

<script>
import axios from 'axios';
import List from './templates/List.vue';
import ListFilters from '@/components/Widgets/Shared/IssueListFilters.vue';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';
import { Modal as ModalBootstrap } from "bootstrap";
import NewIssue from './templates/NewIssue.vue';

export default {
  name: 'App',
  data() {
    return {
      loading: true,
      contractId: '',
      incidentId: '',
      status: '',
      type: '',
      priority: '',
      createdAt: '',
      closedAt: '',
      assignedTo: '',
      issues: [],
      filters: '',
      itemsPerPage: 25,
      currentPage: 0,
      totalItems: 0,
      numberPages: 0,
      from: 0,
      to: 0,
      showNewIssueModal: false
    };
  },
  components: {
    List,
    ListFilters,
    Pagination,
    NewIssue,
  },
  created() {
    this.loadIssues();
  },
  methods: {
    filter(value) {
      this.contractId = value.contractId !== undefined ? value.contractId : this.contractId;
      this.incidentId = value.incidentId !== undefined ? value.incidentId : this.incidentId;
      this.status = value.status !== undefined ? value.status : this.status;
      this.priority = value.priority !== undefined ? value.priority : this.priority;
      this.type = value.type !== undefined ? value.type : this.type;
      this.createdAt = value.createdAt !== undefined ? value.createdAt : this.createdAt;
      this.closedAt = value.closedAt !== undefined ? value.closedAt : this.closedAt;
      this.loadIssues();
    },
    filtercontractId() {
      if (this.contractId !== '' && this.contractId !== undefined) {
        this.filters = `${this.filters}contractId=${this.contractId}&`;
      }
    },
    filterIncidentId() {
      if (this.incidentId !== '' && this.incidentId !== undefined) {
        this.filters = `${this.filters}id=${this.incidentId}&`;
      }
    },
    filterStatus() {
      if (this.status !== '' && this.status !== undefined) {
        this.filters = `${this.filters}status=${this.status}&`;
      }
    },
    filterType() {
      if (this.type !== '' && this.type !== undefined) {
        this.filters = `${this.filters}type=${this.type}&`;
      }
    },
    filterPriority() {
      if (this.priority !== '' && this.priority !== undefined) {
        this.filters = `${this.filters}priority=${this.priority}&`;
      }
    },
    filterCreatedAt() {
      if (this.createdAt !== '' && this.createdAt !== undefined) {
        this.filters = `${this.filters}createdAt=${this.$dateFrontToBack(this.createdAt)}&`;
      }
    },
    filterClosedAt() {
      if (this.closedAt !== '' && this.closedAt !== undefined) {
        this.filters = `${this.filters}closedAt=${this.$dateFrontToBack(this.closedAt)}&`;
      }
    },
    filterPagination() {
      this.filters = `${this.filters}pagination.pageSize=${this.itemsPerPage}&`;
      this.filters = `${this.filters}pagination.page=${parseInt(this.currentPage + 1)}&`;
    },
    selectPage(value) {
      this.currentPage = value;
      this.loadIssues();
    },
    selectOrder(value) {
      console.log(value);
      //Rellenar con el order cuando sepamos el formato
    },
    changeItemsPerPage() {
      this.currentPage = 0;
      this.loadIssues();
    },

    sendRefreshIssuesList() {
      this.loadIssues()
    },
    loadIssues() {
      this.filters = '';
      this.filtercontractId();
      this.filterIncidentId();
      this.filterStatus();
      this.filterType();
      this.filterPriority();
      this.filterCreatedAt();
      this.filterClosedAt();
      this.filterPagination();

      this.loanding = true;

      if (this.filters !== '') {
        this.filters = `?${this.filters}`;
      }

      const vm = this;

      axios.get(`/incidents${this.filters}`)
        .then((response) => {
          this.loading = false
          vm.issues = response.data.incidents;
          vm.totalItems = response.data.totalElements;
          vm.numberPages = vm.totalItems % vm.itemsPerPage === 0
            ? vm.totalItems / vm.itemsPerPage
            : parseInt(vm.totalItems / vm.itemsPerPage, 10) + 1;

          vm.from = (vm.currentPage * vm.itemsPerPage) + 1;
          vm.to = (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage > vm.totalItems
            ? vm.totalItems
            : (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage;
        });
      this.loanding = false;
    },
    openIssueModal(identifier) {
      this.showNewIssueModal = true
       this.$nextTick(() => {
        var myModal = new ModalBootstrap(document.getElementById(identifier))
        myModal.show()
      })
    },
  },
}

</script>



<style lang="scss" scoped>
.dropzone-container {
  max-height: unset;
}
</style>
